import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { provideKeycloakAngular } from '@/config/keycloak.config';
import { provideEnvironmentIndicator } from '@/config/environment.config';
import { CnfPreset } from '@/config/theme.preset';
import { httpErrorInterceptor } from '@/interceptors/http-error.interceptor';
import { includeBearerTokenInterceptor } from 'keycloak-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideKeycloakAngular(),
        provideEnvironmentIndicator(),
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
        provideHttpClient(withFetch(), withInterceptors([includeBearerTokenInterceptor, httpErrorInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: CnfPreset, options: { darkModeSelector: '.app-dark' } } }),
        MessageService
    ]
};
